import React from "react";
import {useTranslation} from "react-i18next";

import {UI_PERMISSION_TYPE} from "../../Components/adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import {ICON_NAMES} from "../generalConstants.js/generalConstants";
import ToolTip from "../ToolTip";

import IconButton from "./IconButton";

const DownloadBtn = ({url, uiPermissionType = UI_PERMISSION_TYPE.READABLE}) => {
  const {t} = useTranslation();
  const fileName = url.split("/").pop();
  const handleDownload = async e => {
    e.preventDefault();
    try {
      const blob = await fetch(url).then(r => r.blob());
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || url.split("/").pop();
      a.click();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };
  return (
    <ToolTip title={t("Download")}>
      <a href={url} onClick={handleDownload}>
        <IconButton ariaLabel="Download" nameIcon={ICON_NAMES.DOWNLOAD_CLOUD} uiPermissionType={uiPermissionType} />
      </a>
    </ToolTip>
  );
};

export default DownloadBtn;
